<template>
  <Popup
      :close-on-click-overlay="false" class="popup_box" v-model="showFrame"
      mode="center"
      @close="close"
      @open="open"
  >
    <div class="enterAmount">
      <div v-if="vaType == 1" class="enterAmount_title"> 當前還款金額</div>
      <div v-if="vaType == 1" class="enterAmount_info" :class="isEdit && 'enterAmount_info_input'">
        <input

            class="oOnline_input"
            :focus="focusState"
            @blur="blur"
            type="number"
            v-model="formData.amount"
        />
      </div>
      <!-- <div v-if="vaType == 2" class="enterAmount_title"> 展期金額 </div> -->
      <!-- <div v-if="vaType == 2" class="enterAmount_info enterAmount_info2">
        <span class="oOnline_input">
          {{formData.amount}}
        </span>
      </div> -->
      <div class="enterAmount_title"> 銀行名稱</div>
      <div class="enterAmount_info" :class="isEdit && 'enterAmount_info_input'">

        <Field
            class="oOnline_input oOnline_select"
            readonly
            name="bank_name"
            :value="formData.bank_name"
            placeholder="請選擇銀行名稱"
            @click="realFocus('bank_name')"
            :rules="[{ required: true }]"
        >
          <template #right-icon>
            <img
                class="right_img"
                src="@/assets/userInfo/right@2x.png"
                alt=""
            />
          </template>
        </Field>

        <Popup round v-model="bankCodePopup" position="bottom" get-container="body"
        >
          <Field
              placeholder="查詢銀行"
              v-model="keyWord"
              clearable
              left-icon="search"
              @input="handleSearchNations(keyWord)"
          />
          <Picker
              confirm-button-text="確定"
              cancel-button-text="取消"
              show-toolbar
              value-key="text"
              :columns="currBankCodeOptions"
              :default-index="bankCodeDefaultIndex"
              @confirm="bankCodeChange"
              @cancel="bankCodePopup = false"
          >
            <template #option="text">
              <div class="option_item">
                {{ text.text }}
              </div>
            </template>
          </Picker>
        </Popup>
      </div>
      <div class="enterAmount_title"> 還款帳戶</div>
      <div class="enterAmount_info" :class="isEdit && 'enterAmount_info_input'">
        <input
            class="oOnline_input"
            :focus="focusState"
            @blur="blur"
            type="number"
            v-model="formData.bankAccount"
        />
      </div>
      <div class="enterAmount_desc">⚠️務必使用填寫的還款帳號與金額才能正常入帳，否則會被銀行7天內才退回原帳戶⚠️</div>
      <div class="enterAmount_option">
        <Button
            class="enterAmount_button enterAmount_button_cancel"
            text="取消"
            size="normal"
            type="info"
            @click="cancel"
        ></Button>
        <Button
            class="enterAmount_button"
            text="確定"
            size="normal"
            type="info"
            @click="submint"
        ></Button>
      </div>
    </div>
  </Popup>
</template>

<script>
import {Popup, Button, Picker, Field} from "vant";
import {formatMoney} from "@/utils";
// import LableBox from "@/components/lable-box";
import {getBankList} from "@/services/order";

export default {
  data() {
    return {
      showFrame: this.isShowFrame,
      isEdit: false,
      lastAmount: undefined,
      bankCodePopup: false,
      bankCodeDefaultIndex: 0,
      focusState: false,
      keyWord: "",
      currBankCodeOptions: [],
      formData: {
        amount: "",
        bankName: "",
        bank_name: "",
        bank_code: "",
        bankAccount: "",
      }
    };
  },
  components: {
    Popup,
    Button,
    Field,
    Picker,
    // LableBox,
  },
  props: {
    isShowFrame: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    payAmount: {
      type: [Number, String],
    },
    vaType: {
      type: [Number, String],
      default: function () {
        return 1;
      },
    },
  },
  watch: {
    isShowFrame(val) {
      this.showFrame = val;
      if (val) {
        this.init();
      }
    },
    payAmount(val) {
      this.formData.amount = val;
    },
  },
  created() {
    this.formData.amount = this.payAmount;
    this.getBankList();
    this.init();
  },
  methods: {
    formatMoney,
    handleSearchNations(keyWord) {
      console.log("keyWord", keyWord);
      this.currBankCodeOptions = this.bankCodeOptions.filter((v) => {
        return v.text.toLowerCase().includes(keyWord.toLowerCase());
      });
    },
    async getBankList() {
      let bankList = await getBankList({pay_type: "1"});
      if (bankList.code == 200) {
        this.bankCodeOptions = bankList.result.map((item) => {
          return {
            // text: item.bank_name + "(" + item.bank_alias + ")",
            text: item.bank_name,
            value: item.bank_code,
          };
        });
        this.currBankCodeOptions = JSON.parse(
            JSON.stringify(this.bankCodeOptions)
        );
      }
    },
    realFocus(str) {
      if (str == "bank_name") {
        this.bankCodePopup = true;
      }
    },
    // 银行选择
    bankCodeChange(value) {
      // this.formData.bank_code = value;
      this.formData.bank_name = value.text;
      this.formData.bank_code = value.value;
      this.bankCodePopup = false;

      // 过滤相应的银行***
      let bankObj = this.bankCodeOptions.filter(
          (item) => item.value === value.value
      )[0];
      this.formData.bankName = bankObj.text;
    },
    init() {
      this.lastAmount = this.formData.amount;
      // this.$api.getva();
    },
    blur() {
      this.focusState = false;
    },
    updStatus() {
      this.isEdit = !this.isEdit;
      if (this.isEdit) {
        this.$nextTick(() => {
          this.focusState = true;
        });
      }
    },
    submint() {
      if (Number(this.formData.amount) < 500) {
        this.$toast("單次還款至少500");
        return;
      }
      if (!this.formData.bank_code) {
        this.$toast("請選擇銀行名稱");
        return;
      }
      if (!this.formData.bankAccount) {
        this.$toast("請輸入還款賬戶");
        return;
      }
      // if (Number(this.amount) > Number(this.payAmount)) {
      //   // this.amount = this.payAmount;
      //   this.$toast("超過最大還款金額");
      //   return;
      // }
      this.isEdit = false;
      this.$emit("submint", this.formData);
    },
    cancel() {
      this.showFrame = false;
      this.$emit("cancel");
    },
    open() {
    },
    close() {
      this.showFrame = false;
    },
  },
};
</script>

<style lang="less" scoped>
.popup_box {
  width: 315px;
  background: #ffffff;
  box-shadow: 0px 1px 6px 0px rgba(229, 248, 242, 0.5);
  border-radius: 10px;
  padding-bottom: 20px;
}

.enterAmount {

  .enterAmount_title {
    margin-left: 20px;
    margin-top: 32px;
    box-sizing: border-box;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
  }

  .enterAmount_info {
    margin: 0 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    height: 55px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.8);


    .enterAmount_number {
      width: 80%;
      height: 100%;
      padding-left: 20px;
      overflow: auto;
      font-size: 28px;
      font-family: LucidaGrande-Bold, LucidaGrande;
      font-weight: bold;
      color: #000000;

      display: flex;
      align-items: center;
    }

    .oOnline_input {
      width: 250px;
      height: 100%;
      box-sizing: border-box;
      padding-left: 20px;
      font-size: 28px;
      font-family: LucidaGrande-Bold, LucidaGrande;
      font-weight: bold;
      color: #3F8CFF;

      display: flex;
      align-items: center;
    }

    .oOnline_select {
      font-size: 16px;
      font-weight: inherit;

    }

    /deep/ .info_placeholder {
      color: #6d7278;
    }

    .enterAmount_edit {
      margin-right: 10px;
      height: 55px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        // position: absolute;
        // top: 0;
        // right: -16px;

        width: 25px;
        height: 26px;
      }
    }
  }

  .enterAmount_info2 {
    border-bottom: none;
  }

  .enterAmount_info_input {
    border-bottom: 1px solid #3F8CFF;
  }

  .enterAmount_desc {
    margin: 0 20px;
    margin-top: 16px;
  }

  .enterAmount_option {
    margin: 0 20px;
    margin-top: 16px;
    display: flex;
    align-items: center;

    .enterAmount_button {
      border: none;

      width: 100%;
      height: 42px;
      background: #3F8CFF;
      border-radius: 14px;
      box-shadow: 0px 6px 12px 0px rgba(63, 140, 255, 0.26);

      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
    }

    .enterAmount_button_cancel {
      background: none;
      margin-right: 20px;

      height: 42px;
      border-radius: 14px;
      border: 1px solid #3F8CFF;
      box-shadow: none;

      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #3F8CFF;
    }
  }
}

.right_img {
  width: 24px;
  height: 24px;
}
</style>
